<app-navbar *ngIf="!isLoginPage" (navOpenChange)="navOpen = $event"></app-navbar>
<div class="transition-all duration-300"
     [class.ml-12]="!navOpen && !isLoginPage"
     [class.ml-48]="navOpen && !isLoginPage"
     [class.ml-0]="isLoginPage">
  <router-outlet></router-outlet>
</div>